import { AUTO_HEIGHT_COMP_TYPES, Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { hasResponsiveLayout } from '../../utils/hasResponsiveLayout'
import { StylableHorizontalMenuProps } from '@wix/thunderbolt-components-native'
import { FeatureRefs } from '../cssFeatures.types'

export const autoHeightWrapper = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: (component: Component, refs: FeatureRefs<'pinnedLayout'>) => {
		return {
			metaSiteId: envRefs.metaSiteId,
			isAutoHeightWrapperExperimentOn: envRefs.experiment('specs.thunderbolt.catharsis_auto_height_wrapper'),
			isStylableHorizontalMenWithWrapperExperimentOn: envRefs.experiment(
				'specs.thunderbolt.stylableHorizontalMenWithWrapper'
			),
			compProps:
				component.componentType === 'StylableHorizontalMenu'
					? refs.propertyQuery<StylableHorizontalMenuProps>(component.propertyQuery!)
					: null,
			isMeshV2: envRefs.experiment('specs.thunderbolt.mesh2'),
		}
	},
	toViewItem: (component: Component, deps): boolean => {
		if (
			deps &&
			deps.isAutoHeightWrapperExperimentOn === true &&
			// TODO: REMOVE 'deps.isMeshV2' when hasResponsiveLayout supports mesh case
			(!hasResponsiveLayout(component) || deps.isMeshV2) &&
			deps.metaSiteId && //  only regular sites (no mini sites with auto height wrapper)
			(AUTO_HEIGHT_COMP_TYPES[component.componentType] ||
				(deps.isStylableHorizontalMenWithWrapperExperimentOn &&
					component.componentType === 'StylableHorizontalMenu' &&
					deps.compProps?.menuMode === 'wrap')) // Add StylableHorizontalMenu to auto height wrapper only if it's in wrap mode
		) {
			return true
		}
		return false
	},
})

export const autoHeightWrapperViewer = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: () => null,
	toViewItem: (): boolean => false,
})
